import React from "react";
import "./Footer.css";
import { personalInfo } from "../data/portfolioData";
import { HiArrowUp } from "react-icons/hi";

function Footer() {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer-container">
      <div className="container footer-content">
        <div className="footer-left">
          <p className="footer-copy">
            © {new Date().getFullYear()} {personalInfo.name}. All rights reserved.
          </p>
        </div>

        <div className="footer-right">
          <button
            className="back-to-top-btn"
            onClick={scrollToTop}
            aria-label="Back to top"
            title="Back to top"
          >
            <span>Back to top</span>
            <HiArrowUp size={16} />
          </button>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
